<template>
    <div class="container">
        <div class="banner">
            <div class="main wow fadeInUp" ata-wow-delay="0.2s">
                探索创新之旅，携手共创未来
            </div>
        </div>
        <!-- 关于我们 -->
        <div class="about">
            <div class="about_content">
                <div class="title wow fadeInUp" ata-wow-delay="0.2s">关于我们</div>
                <div class="about_content_main wow fadeInLeft" ata-wow-delay="0.2s">
                   <div class="about_content_main_left">
                        <div class="l_t">广州二进制软件技术有限公司</div>
                        <div class="l_c">广州二进制软件技术有限公司，是一家致力于提供高质量软件开发和技术解决方案的公司。 我们拥有一支 由专业技术人员组成的团队，专注于为客户提供创新、可靠且高效的软件产 品和服务。无论 是初创企业还是大型企业，我们都能根据客户的需求量身定制解决方案， 助力他们在数字化 转型的道路上取得成功。</div>
                        <div class="l_t">我们的使命</div>
                        <div class="l_c">我们的使命是通过创新的技术和卓越的服务，帮助客户实现业务目标。我们致力于成为客 户可信赖的合作伙伴，推动他们在竞争激烈的市场中脱颖而出。</div>
                    </div>
                   <img src="../../assets/image/gywm_tp.png" alt="" class="wow fadeInRight" ata-wow-delay="0.2s">
                </div>
            </div>
        </div>
        <!-- 核心价值 -->
        <div class="core">
            <div class="core_content">
                <div class="title wow fadeInUp" ata-wow-delay="0.2s">核心价值</div>
                <div class="core_content_main">
                   <div class="core_content_main_item wow fadeInLeft" ata-wow-delay="0.2s">
                        <div class="img_out">
                            <img src="../../assets/image/chengxin.png" alt="">
                        </div>
                        <div class="item_r">
                            <div class="item_r_t">创新</div>
                            <div class="item_r_c">我们不断追求技术创新，致力于 为客户提供最前沿的解决方案。</div>
                        </div>
                   </div>
                   <div class="core_content_main_item wow fadeInRight" ata-wow-delay="0.2s">
                        <div class="img_out">
                            <img src="../../assets/image/zl.png" alt="">
                        </div>
                        <div class="item_r">
                            <div class="item_r_t">质量</div>
                            <div class="item_r_c">我们坚持最高的质量标准，确保 每一个项目都能够达到甚至超越 客户的期望。</div>
                        </div>
                   </div>
                   <div class="core_content_main_item wow fadeInLeft" ata-wow-delay="0.2s">
                        <div class="item_r">
                            <div class="item_r_t">客户至上</div>
                            <div class="item_r_c">我们重视每一位客户的需求，提 供个性化的服务，帮助客户实现 其业务目标。</div>
                        </div>
                        <div class="img_out">
                            <img src="../../assets/image/khzs.png" alt="">
                        </div>
                   </div>
                   <div class="core_content_main_item wow fadeInRight" ata-wow-delay="0.2s">
                        <div class="item_r">
                            <div class="item_r_t">诚信</div>
                            <div class="item_r_c">我们以诚实守信的态度对待每一 个客户，建立长期的合作关系。</div>
                        </div>
                        <div class="img_out">
                            <img src="../../assets/image/cx.png" alt="">
                        </div>
                   </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {

        }
    },
    mounted() {
        var wow = new this.$wow.WOW({
            boxClass: 'wow',
            animateClass: 'animated',
            offset: 0,
            mobile: true,
            live: true
        });
        wow.init();
    },
}
</script>
<style scoped lang="scss">
$width: 1200px;
.container {
    width: 100vw;
    height: auto;
    .title {
        width: 100%;
        font-size: 30px;
        color: #333333;
        font-weight: bold;
        margin: 0 0 85px 0;
        padding-top: 85px;
        box-sizing: border-box;
        text-align: center;
        position: relative;
        &::after {
            content: '';
            width: 50px;
            height: 6px;
            background: #3C6AFD;
            position: absolute;
            left: 50%;
            bottom: -45px;
            transform: translateX(-50%);
        }
    }
    .banner {
        width: 100%;
        height: 550px;
        background: url('../../assets/image/gywm_banner.png');
        background-repeat: no-repeat;
        background-size: 100% auto;
        .main {
            width: $width;
            margin: 0 auto;
            color: #FFFFFF;
            font-weight: bold;
            font-size: 46px;
            text-align: center;
            line-height: 550px;
        }
    }
    .about {
        width: 100%;
        height: 660px;
        &_content {
            width: $width;
            height: 100%;
            margin: 0 auto;
            display: flex;
            flex-direction: column;
            position: relative;
            &_main {
                display: flex;
                column-gap: 40px;
                &_left {
                    padding-top: 40px;
                    box-sizing: border-box;
                    .l_t {
                        font-size: 20px;
                    }
                    .l_c {
                        font-size: 14px;
                        color: #666666;
                        margin-top: 20px;
                        margin-bottom: 40px;
                    }
                }
                img {
                    width: 620px;
                    height: 410px;
                    object-fit: cover;
                }
            }
        }
    }
    .core {
        width: 100%;
        height: 892px;
        background: url('../../assets/image/hxjz_bg.png');
        background-repeat: no-repeat;
        background-size: 100% auto;
        &_content {
            width: $width;
            height: 100%;
            margin: 0 auto;
            display: flex;
            flex-direction: column;
            position: relative;
            &_main {
                display: grid;
                grid-template-columns: repeat(2, 1fr);
                &_item {
                    display: flex;
                    overflow: hidden;
                    .img_out {
                        width: 300px;
                        height: 300px;
                        overflow: hidden;
                        img {
                            width: 300px;
                            height: 300px;
                            object-fit: cover;
                            transition: all 0.3s ease;
                        }
                        img:hover {
                            transform: scale(1.1);
                        }
                    }
                    .item_r {
                        flex: 1;
                        padding: 60px 30px;
                        box-sizing: border-box;
                        &_t {
                            font-size: 24px;
                            font-weight: bold;
                            margin-bottom: 36px;
                            position: relative;
                            &::after {
                                content: '';
                                width: 30px;
                                height: 4px;
                                background: #3C6AFD;
                                position: absolute;
                                left: 0;
                                bottom: -18px;
                            }
                        }
                        &_c {
                            font-size: 16px;
                            color: #666;
                        }
                    }
                }
            }
        }
    }
}
</style>